import React, { useState } from "react";
import { createUseStyles } from "react-jss";
import GenericBasicInfo from "../../../../../../components/cards/GenericBasicInfo";
import {
  cardStyles,
  modalGenericStyles,
  variables,
} from "../../../../../../variables";
import PropTypes from "prop-types";
import _ from "lodash";
import { DateTime } from "luxon";
import { useQuery } from "@tanstack/react-query";
import { retrieveTRAVendors } from "../../../../../../api/Vendor/Trains";
import { genericRequestErrorHandler } from "../../../../../../api";
import Loader from "../../../../../../components/Loader";
import VendorsDocuments from "../../../components/VendorsDocuments";
import ListPaymentTerms from "../../../components/paymentsTerms/ListPaymentTerms";
import TabStrip from "../../../../../../components/TabStrip";
import { CustomButton } from "../../../../../../components/CustomButton";
import VendorTRAConfigLogsTab from "./VendorTRAConfigLogsTab";
import DepositStatments from "../../../../CommonCRMModals/DepositStatmentss/DepositStatment";
import ProformaStatments from "../../../../CommonCRMModals/Proforma/List";
import { Price } from "../../../../../../components/Price";

const statusOptions = {
  "": "-----",
  AC: "Active",
  IN: "Inactive",
  CA: "Candidate",
};
const trueFalseMapping = {
  true: "Yes",
  false: "No",
};

const styles = createUseStyles({
  ...modalGenericStyles,
  DetailTrainVendorModal: { ...modalGenericStyles.modal },
  modalCard: {
    ...modalGenericStyles.card,
    gridTemplateRows: "max-content max-content 1fr max-content",
  },
  modalCardHeader: {
    ...modalGenericStyles.cardHeader,
  },
  modalCardBody: {
    display: "grid",
    padding: variables.double_gap,
    minHeight: "30vh",
    maxHeight: "70vh",
    overflow: "auto",
  },
  modalCardActions: {
    ...modalGenericStyles.cardActions,
  },
  card: cardStyles.card,
  cardHeader: cardStyles.header,
  cardBody: {
    ...cardStyles.body,
    gap: variables.normal_gap,
  },
  row: {
    display: "grid",
    gridTemplateColumns: "repeat(1, 1fr)",
    gap: variables.normal_gap,
  },
  [`@media ${variables.media.smallscreen}`]: {
    cardBody: { justifyContent: "center" },
    tabs: { gridAutoFlow: "column", justifyContent: "center" },
    tabBtns: {
      fontSize: "small",
    },
    row: {
      gridTemplateColumns: "1fr 1fr",
    },
  },
});
const DetailTrainVendorModal = ({ id, onClose }) => {
  const classes = styles();

  const [activeTab, setActiveTab] = useState("basicData");

  const menuTabs = {
    basicData: "Basic Data",
    paymentTerms: "Payment Terms",
    proforma: "Proforma Statment",
    creditStatments: "Credit Statements",
    documents: "Documents",
    logs: "Logs",
  };

  const { data: train, isLoading: retrieveLoading } = useQuery({
    queryKey: ["DetailVendorTRA", id],
    queryFn: async () => await retrieveTRAVendors({ id: id }),
    onError: (error) => genericRequestErrorHandler(error),
  });

  const basicDataCpl = [
    ["Id", "id"],
    ["Member", "member"],
    ["Market Type", "market_type"],
    [
      "Notify Amount",
      null,
      <Price
        currency={train?.data?.vendor_data?.currency}
        price={train?.data?.notify_amount}
      />,
    ],
    ["Config uid", null, _.get(train, "data.config_uid[0]", "") || "N/A"],
    ["Notes", "notes"],
    [
      "Payment Validation",
      null,
      _.get(trueFalseMapping, _.get(train, "data.payment_validation")),
    ],
    ["CXL Strategy Time", "cxl_strategy_time"],
    [
      "CXL Strategy Daysahead",
      null,
      _.get(train, "data.cxl_strategy_daysahead", []) === 0
        ? "0"
        : _.get(train, "data.cxl_strategy_daysahead"),
    ],
    [
      "Block Non Refundable",
      null,
      _.get(trueFalseMapping, _.get(train, "data.block_nonrefundable")),
    ],
    [
      "Status",
      null,
      _.get(statusOptions, _.get(train, "data.status", "") || "N/A"),
    ],
  ];

  const creatorData = [
    ["Creator", "creator"],
    [
      "Created",
      null,
      DateTime.fromISO(_.get(train, "data.created")).toLocaleString(
        DateTime.DATE_MED_WITH_WEEKDAY
      ),
    ],
  ];
  const editorData = [
    ["Last Editor", "last_editor"],
    [
      "Edited",
      null,
      DateTime.fromISO(_.get(train, "data.edited")).toLocaleString(
        DateTime.DATE_MED_WITH_WEEKDAY
      ),
    ],
  ];

  const VendorDataCpl = [
    [
      "Vendor",
      null,
      _.get(train, "data.vendor", "").split("tra__")[1] || "N/A",
    ],
    ["Username", null, _.get(train, "data.vendor_data.username")],
    ["Password", null, _.get(train, "data.vendor_data.password")],
    ["Api Key", null, _.get(train, "data.vendor_data.apikey")],
    ["Api URL", null, _.get(train, "data.vendor_data.api_url")],
    ["Application key", null, _.get(train, "data.vendor_data.application_key")],
  ];

  const vendorContactData = [
    ["Title", "title"],
    ["First Name", "first_name"],
    ["Last Name", "last_name"],
    ["Email", "email"],
  ];

  return (
    <div id="DetailVendorTRAModal" className={classes.DetailTrainVendorModal}>
      <div className={classes.modalCard}>
        <div className={classes.modalCardHeader}>
          <span>Details Train Vendor</span>
        </div>
        <TabStrip
          tabs={Object.entries(menuTabs)}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <div className={classes.modalCardBody}>
          {retrieveLoading ? (
            <Loader />
          ) : (
            <React.Fragment>
              {activeTab === "basicData" && (
                <React.Fragment>
                  <div className={classes.row}>
                    <div className={classes.cardBody}>
                      <GenericBasicInfo
                        header={"Basic Data"}
                        cardInfo={basicDataCpl}
                        objectData={_.get(train, "data", {})}
                      />
                    </div>
                    <div className={classes.cardBody}>
                      <GenericBasicInfo
                        header={"Creator Data"}
                        cardInfo={creatorData}
                        objectData={_.get(train, "data", {})}
                      />
                      <GenericBasicInfo
                        header={"Editor Data"}
                        cardInfo={editorData}
                        objectData={_.get(train, "data", {})}
                      />
                    </div>
                  </div>
                  <div className={classes.row}>
                    <div className={classes.cardBody}>
                      <GenericBasicInfo
                        header={"Vendor Data"}
                        cardInfo={VendorDataCpl}
                        objectData={_.get(train, "data.vendor_data", {})}
                      />
                    </div>
                    <div className={classes.cardBody}>
                      <GenericBasicInfo
                        header={"Vendor Contact Data"}
                        cardInfo={vendorContactData}
                        objectData={_.get(
                          train,
                          "data.vendor_data.contact_details",
                          {}
                        )}
                      />
                    </div>
                  </div>
                </React.Fragment>
              )}
              {activeTab === "paymentTerms" && (
                <ListPaymentTerms
                  showAddButton={true}
                  vendorId={_.get(train, "data.id")}
                />
              )}
              {activeTab === "proforma" && (
                <ProformaStatments
                  invalidationKey="DetailsSubAgentModal"
                  entityType="vendor"
                  entityData={_.get(train, "data", {})}
                />
              )}
              {activeTab === "creditStatments" && (
                <DepositStatments
                  invalidationKey="DetailVendorTRA"
                  entityType="vendor"
                  entityData={_.get(train, "data", {})}
                />
              )}
              {activeTab === "documents" && (
                <VendorsDocuments
                  queryKey={`vendor_train_document`}
                  showAddButton={true}
                  tags={[`vendor__${_.get(train, "data.id")}`]}
                  entityData={_.get(train, "data", {})}
                />
              )}
              {activeTab === "logs" && <VendorTRAConfigLogsTab />}
            </React.Fragment>
          )}
        </div>
        <div className={classes.cardActions}>
          <CustomButton id="cancel" appearance="ghost" onClick={onClose}>
            <strong>Cancel</strong>
          </CustomButton>
        </div>
      </div>
    </div>
  );
};
DetailTrainVendorModal.propTypes = {
  id: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default DetailTrainVendorModal;
